//src/components/ReceiveItemSingle.jsx :-
import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { tokens } from "../../theme";
import { useSelector } from 'react-redux';
import { useTheme } from "@mui/material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'; // Import Close icon
import axios from 'axios';
import env from "react-dotenv";

const ReceiveItemSingle = ({ open, handleClose, fetchProducts }) => {
  const [products, setProducts] = useState([]);
  const [productId, setProductId] = useState('');
  const [quantity, setQuantity] = useState('');
  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState('');
  const [leadTime, setLeadTime] = useState('');
  const [grnNo, setGrnNo] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const submitLockRef = useRef(false);

  const user = useSelector((state) => state.user);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!location.key || location.key === 'default') {
      navigate("/");
    }
  }, [location, navigate]);

  useEffect(() => {
    fetchProductsList();
    fetchVendorsList();
  }, []);

  const fetchProductsList = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/products`);
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const fetchVendorsList = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/vendors`);
      setVendors(response.data);
    } catch (error) {
      console.error('Error fetching vendors:', error);
    }
  };

  const handleUpdateQuantity = async (action) => {
    if (isSaving || submitLockRef.current) {
      return;
    }
    if (!productId || !quantity || quantity <= 0 || !selectedVendor || !leadTime || !grnNo || !selectedDate) {
      alert('Please provide valid product, quantity, vendor, lead time, GRN No., and date values.');
      return;
    }

    try {
      submitLockRef.current = true;
      setIsSaving(true);
      const userName = user?.userName;
      await axios.patch(
        `${process.env.REACT_APP_PJCBACKEND_URL}/api/products/update-quantity-receive`,
        {
          productId,
          quantity: parseInt(quantity, 10),
          action,
          userName,
          vendorId: selectedVendor,
          leadTime,
          grnNo,
          grnDate: selectedDate,
        }
      );
      fetchProducts(); // Refresh the product list
      handleCloseModal(); // Close the dialog
      navigate('/rawMaterialHome');
    } catch (error) {
      console.error('Error updating quantity:', error);
      alert('Failed to update quantity. Please try again.');
    } finally {
      submitLockRef.current = false;
      setIsSaving(false);
    }
  };

  // Function to reset form values
  const resetForm = () => {
    setProductId('');
    setQuantity('');
    setSelectedVendor('');
    setLeadTime('');
    setGrnNo('');
    setSelectedDate('');
  };
  // Close modal and reset form without refreshing
  const handleCloseModal = () => {
    resetForm();
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleCloseModal} maxWidth="xs" fullWidth>
      <DialogTitle>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" sx={{ flex: 1, textAlign: 'center' }}>
        Receive Item
        </Typography>
        <IconButton onClick={handleCloseModal} sx={{ position: 'absolute', right: 8, top: 8 }}>
        <CloseIcon />
        </IconButton>
    </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection="column" gap={2}>
          <TextField
            select
            label="Select Raw material"
            value={productId}
            onChange={(e) => setProductId(e.target.value)}
            fullWidth
          >
            <MenuItem value="">
                Select Raw material
            </MenuItem>
            {products
              .sort((a, b) => a.product_name.localeCompare(b.product_name)) // Sort products by product_name in ascending order
              .map((product) => (
              <MenuItem key={product.id} value={product.id}>
                {product.product_name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Select Vendor"
            value={selectedVendor}
            onChange={(e) => setSelectedVendor(e.target.value)}
            fullWidth
          >
            <MenuItem value="">
                Select Vendor
            </MenuItem>
            {vendors
              .sort((a, b) => a.vendor_name.localeCompare(b.vendor_name)) // Sort products by vendor_name in ascending order
              .map((vendor) => (
              <MenuItem key={vendor.id} value={vendor.id}>
                {vendor.vendor_name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="Quantity"
            type="number"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            fullWidth
          />
          <TextField
            label="Lead Time"
            value={leadTime}
            onChange={(e) => setLeadTime(e.target.value)}
            fullWidth
          />
          <TextField
            label="GRN No."
            value={grnNo}
            onChange={(e) => setGrnNo(e.target.value)}
            fullWidth
          />
          <TextField
            label="GRN Date"
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button onClick={handleCloseModal} color="secondary" disabled={isSaving}
        sx={{ marginRight: 2,':hover': {
                      bgcolor: '#4863C0', // theme.palette.primary.main
                      color: 'white',
            }, }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => handleUpdateQuantity('receive')}
          disabled={isSaving}
          sx={{backgroundColor:'#4863A0',':hover': {
                      bgcolor: '#4863C0', // theme.palette.primary.main
                      color: 'white',
              },}} 
          variant="contained"
        >
          Receive
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReceiveItemSingle;
